import React from 'react';
import {
  CardHeader,
  CardText,
  Card,
  FontIcon,
  IconMenu,
  FlatButton,
  MenuItem,
  Dialog,
  IconButton,
  Table,
  TableRow,
  TableRowColumn,
  TableBody,
  TableHeaderColumn,
  TableHeader,
} from 'material-ui';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import SingleLocList from './single-loc';
import GroupTemplateIcon from 'material-ui/svg-icons/content/link';
import SendContract from 'material-ui/svg-icons/content/send';
import DownloadAll from 'material-ui/svg-icons/action/get-app';
import { editTemplateGroup } from '../../../../stores/contracting/template-list/template-list-actions';
import R from 'ramda';
import A from 'aphrodite';
import moment from 'moment';
import queryString from 'query-string';

const styles = A.StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', alignItems: 'center', width: '93%' },
  texts: { width: '75%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  companyName: { fontSize: '14px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', width: '90%', display: 'flex', alignItems: 'center' },
  locationName: { fontSize: '13px', marginLeft: '28px', color: '#00bcd4' },
  actions: { width: '20%', marginLeft: '1%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '10%', cursor: 'pointer' },
});
const getGenitiveCase = (string) => {
  if (!string) return string;
  if (string.slice(-1) === 's') return `${string}'`;
  return `${string}'s`;
};

class TemplateGroupBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPartners: false,
      expanded: props.expanded || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.expanded !== nextProps.expanded) {
      this.setState({ expanded: nextProps.expanded });
    }
  }
  goToSendAssets = () => {
    const {
      companyName,
      templateGroup,
    } = this.props;
    window.location = `${
      process.env.NEW_SYSTEM_URL
    }/partner-management/send-assets?${queryString.stringify({
      go_back_to: window.location.href,
      templategroupid: [templateGroup._id],
      message: `Please find ${getGenitiveCase(companyName)} ${moment(templateGroup.startDate).utc().format('DD MMM YYYY')} - ${moment(templateGroup.endDate).utc().format('DD MMM YYYY')} rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.`,
      subject: `${companyName} ${moment(templateGroup.startDate).utc().get('year')}-${moment(templateGroup.endDate).utc().get('year')} Rates`,
    })}&jwt=${localStorage.getItem('jwt')}`;
  };
  render() {
    const {
      templateGroup,
      docs,
      allTemplates,
      onExpandChange,
      router,
      updateProps,
      downloadPdfZip,
      editTemplateGroup,
    } = this.props;
    const { expanded, showPartners } = this.state;
    return (<Card
      onExpandChange={() => this.setState({ expanded: !expanded })}
      expanded={expanded}
      style={{ boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}
    >
      <CardHeader
        style={{ padding: '6px' }}
        textStyle={{ display: 'none' }}
        showExpandableButton
      >
        <div className={A.css(styles.container)}>
          <div className={A.css(styles.texts)} onClick={() => this.setState({ expanded: !expanded })}>
            <div className={A.css(styles.companyName)}>
              <GroupTemplateIcon color="rgba(0, 0, 0, 0.65)" style={{ marginRight: '4px' }}/>
              {templateGroup.groupName}
            </div>
            <div className={A.css(styles.locationName)}>
              {`${docs.length} ${pluralize('template', docs.length)}`}
            </div>
          </div>
          <FlatButton
            secondary
            className={A.css(styles.comments)}
            onTouchTap={() => this.setState({ showPartners: true })}
            icon={<FontIcon className="tc-icon-users" />}
            label={`${R.pathOr(0, ['sentPartners', 'length'], templateGroup)}`}
          />
          <div className={A.css(styles.yearNtimestamp)}>{moment(templateGroup.startDate).get('year')} - {moment(templateGroup.endDate).get('year')}</div>
          <IconButton
            tooltip="Download All"
            tooltipPosition="top-right"
            onClick={e => e.stopPropagation()}
            style={{ padding: '0', width: '36px', height: '24px' }}
            onTouchTap={() => downloadPdfZip(R.map(R.pick(['_id', 'templateName', 'locationName']), docs), templateGroup.groupName)}
          >
            <DownloadAll color="rgba(0, 0, 0, 0.54)" />
          </IconButton>
          <IconButton
            tooltip="Send Template Group"
            tooltipPosition="top-right"
            onClick={e => e.stopPropagation()}
            style={{ padding: '0', width: '36px', height: '24px' }}
            onTouchTap={this.goToSendAssets}
          >
            <SendContract color="rgba(0, 0, 0, 0.54)" />
          </IconButton>
          <IconMenu
            iconButtonElement={<IconButton
              iconClassName="tc-icon-more_vert"
              iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
              style={{ padding: '0', width: '36px', height: '24px' }}
              tooltip="More Actions"
            />}
          >
            <MenuItem
              leftIcon={<FontIcon
                className="tc-icon-mode_edit"
                color="#00bcd4"
              />}
              primaryText="Edit Template Group"
              tooltipPosition="top-right"
              onTouchTap={() => updateProps({
                editGroupName: templateGroup.groupName,
                editGroupId: templateGroup._id,
                selectedTemplatesForGroup: docs,
                editDialogOpen: true,
                groupWizardTemplates: allTemplates,
              })}
            />
            <MenuItem
              leftIcon={<FontIcon
                className="tc-icon-delete2"
                color="#ff4081"
              />}
              primaryText="Delete Template Group"
              tooltipPosition="top-right"
              onTouchTap={() => editTemplateGroup({
                groupId: templateGroup._id,
                isArchived: true,
              })}
            />
          </IconMenu>
        </div>
      </CardHeader>
      <CardText
        expandable
        style={{ paddingTop: '0px' }}
      >
        <SingleLocList
          docs={docs}
          router={router}
          showLocName
          doNotShowActionButtons
        />
      </CardText>
      <Dialog
        autoScrollBodyContent
        open={showPartners}
        titleStyle={{ padding: '8px 16px' }}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              {`${templateGroup.groupName} - Partner List`}
            </div>
            <IconButton
              iconClassName="tc-icon-close"
              iconStyle={{ color: 'red', fontSize: '32px' }}
              onTouchTap={() => this.setState({ showPartners: false })}
            />
          </div>
        }
        onRequestClose={() => this.setState({ showPartners: false })}
        bodyStyle={{ padding: '2px 24px 24px' }}
        modal
      >
        { R.pathOr(0, ['sentPartners', 'length'], templateGroup) ? <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>Buyer Company Name</TableHeaderColumn>
              <TableHeaderColumn>Email</TableHeaderColumn>
              <TableHeaderColumn>Issued On</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {
              R.propOr([], 'sentPartners', templateGroup).map(({ buyerCompanyName, email, createdAt }, i) => (
                <TableRow key={i}>
                  <TableRowColumn>{buyerCompanyName}</TableRowColumn>
                  <TableRowColumn>{!email ? 'via TourConnect' : email}</TableRowColumn>
                  <TableRowColumn>{moment(createdAt).calendar(null, {
                    sameDay: '[Today]',
                    lastDay: '[Yesterday]',
                    lastWeek: '[Last] dddd',
                    sameElse: 'DD/MM/YYYY',
                  })}</TableRowColumn>
                </TableRow>
              ))
            }
          </TableBody>
        </Table> : (<div style={{ padding: '32px 16px' }}>
          This template group hasn't been sent to any partners yet.
        </div>)
        }
      </Dialog>
    </Card>);
  }
}
const mapStateToProps = ({ user }) => ({
  companyName: user.getIn(['company', 'companyName']),
});

export default connect(mapStateToProps, { editTemplateGroup })(TemplateGroupBox);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/template-group-box.jsx